import defaultConfig from 'config/default-config.yaml'; // URL to versus-br-config.yaml, resolved using alias in webpack

import {configureSportsbook} from '#core/sportsbook-initializer.js';
import {staticHTMLPageFactory} from '#core/components/static-page/static-page-factory.js';

import translations from './config/translations.l10n.yaml'; // This will be transpiled by webpack.translations-loader
import {getTokens} from './config/viewsconfig';
import fonts from './config/fonts.yaml';
import {BASIC_PALETTE} from './config/theme';
import BadRoutePageView from './pages/bad-route-page-view/index.jsx';

import './features/az-overview.js';

function getMojitoConfig() {
    return {
        customRoutes: [
            {
                path: 'terms-and-conditions',
                element: staticHTMLPageFactory({
                    headerKey: '$TERMS_AND_CONDITIONS_PAGE_VIEW.HEADER',
                    filename: 'tc.html',
                    downloadLink: 'tc.pdf',
                }).buildPage(),
            },
            {
                path: 'responsible-gaming',
                element: staticHTMLPageFactory({
                    headerKey: '$RESPONSIBLE_GAMBLING_PAGE_VIEW.HEADER',
                    filename: 'responsible-gambling.html',
                }).buildPage(),
            },
            {
                path: 'faq',
                element: staticHTMLPageFactory({
                    headerKey: '$FAQ_PAGE_VIEW.HEADER',
                    filename: 'faq.html',
                }).buildPage(),
            },
            {
                path: 'betting-rules',
                element: staticHTMLPageFactory({
                    headerKey: '$BETTING_RULES_PAGE_VIEW.HEADER',
                    filename: 'betting-rules.html',
                }).buildPage(),
            },
            {
                path: 'cookies-policy',
                element: staticHTMLPageFactory({
                    headerKey: '$COOKIES_POLICY_PAGE_VIEW.HEADER',
                    filename: 'cookies-policy.html',
                }).buildPage(),
            },
            {
                path: 'promotions',
                element: staticHTMLPageFactory({
                    headerKey: '$PROMOTIONS_PAGE_VIEW.HEADER',
                    filename: 'promotions.html',
                }).buildPage(),
            },
        ],
        services: {
            viewImplementations: {
                BadRoutePageView: {
                    implementation: BadRoutePageView,
                },
            },
        },
    };
}

configureSportsbook({
    getMojitoConfigFn: getMojitoConfig,
    getTokensFn: getTokens,
    configuration: {
        ...defaultConfig,
        translations,
        palette: {
            BASIC: BASIC_PALETTE,
        },
        fonts,
    },
});
